import React, {
  createContext,
  useState,
  useMemo,
  useCallback,
  useEffect
} from 'react';
import PropTypes from 'prop-types';

export const SimplotContext = createContext();

const Provider = ({ children }) => {
  const host = "https://financials.cropwise.com" || 'http://localhost:3000';
  const redirect = `${host}/app/integrations/Simplot`;
  const clientId = "26394ba9-f253-46a0-b013-f84bd22e338c";

  const [step, setStep] = useState(1);
  const goBack = () => {
    setStep(s => Math.max(0, s - 1));
  };

  const goForward = () => {
    setStep(s => s + 1);
  };

  const simplotOauthUrl = `${"https://onelogin.agcocorp.com/051b9332-1f85-46f9-87be-a6ea3157fd86/oauth2/v2.0/authorize?p=b2c_1a_signin_ptx&scope=offline_access+openid+{clientId}&client_id={clientId}&redirect_uri={redirect}&response_type=code"}`
    .replaceAll('{clientId}', clientId)
    .replaceAll('{redirect}', redirect);

  const redirectToSimplotAuthorizeOrgUrl = useCallback(() => {
    globalThis.location.href = `${"https://www.farmengage.com/ThirdPartyAccess/ThirdPartyAuthorizationRedirect?clientid={clientId}&redirectionUrl={redirect}&IsAgcoId=true"}`
      .replaceAll('{clientId}', clientId)
      .replaceAll('{redirect}', redirect);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [canGoNext, setCanGoNext] = useState(false);
  const blockStepForward = () => setCanGoNext(false);
  const releaseStepForward = () => setCanGoNext(true);

  const selectPropertiesStep = 4;

  useEffect(() => {
    if (step === selectPropertiesStep) {
      setCanGoNext(true); // in properties selection there have a specific logic in other context to enable next step
    }
  }, [step]);

  const store = useMemo(
    () => ({
      state: { step, canGoNext },
      gotoStep: setStep,
      goBack,
      goForward,
      simplotOauthUrl,
      redirectToSimplotAuthorizeOrgUrl,
      blockStepForward,
      releaseStepForward
    }),
    [simplotOauthUrl, redirectToSimplotAuthorizeOrgUrl, step, canGoNext]
  );

  return (
    <SimplotContext.Provider value={store}>{children}</SimplotContext.Provider>
  );
};

Provider.defaultProps = {
  children: null
};

Provider.propTypes = {
  children: PropTypes.node
};

export default Provider;
